/**
 * What each piece says about itself — WRITTEN BY `scripts/gen-catalog.mjs`. Do not edit by hand.
 *
 * Read from the `<component>.docs.ts` files that exist, so a piece that starts documenting itself
 * appears here without anybody adding it to a list. A piece with no entry has NOT SAID ANYTHING,
 * which is a different fact from a piece that has declared its sections empty, and the reference
 * page keeps the two apart everywhere it reads them.
 */
import type { ComponentDocs } from './component-docs.js';
import docs0 from './components/app-launcher.docs.js';
import docs1 from './components/breadcrumb.docs.js';
import docs2 from './components/nav-gadget.docs.js';
import docs3 from './components/object-caret.docs.js';
import docs4 from './components/open-records.docs.js';
import docs5 from './components/topbar.docs.js';
import docs6 from './components/tree.docs.js';
import docs7 from './components/workspace-tabs.docs.js';
import docs8 from './components/work-tabs.docs.js';
import docs9 from './components/layout.docs.js';
import docs10 from './components/layout-item.docs.js';
import docs11 from './components/spacer.docs.js';
import docs12 from './components/app-home.docs.js';
import docs13 from './components/page-header.docs.js';
import docs14 from './components/record-header.docs.js';
import docs15 from './components/segmented-filter.docs.js';
import docs16 from './components/tab-strip.docs.js';
import docs17 from './components/accordion.docs.js';
import docs18 from './components/avatar.docs.js';
import docs19 from './components/card-grid.docs.js';
import docs20 from './components/carousel.docs.js';
import docs21 from './components/chart.docs.js';
import docs22 from './components/data-table.docs.js';
import docs23 from './components/detail-section.docs.js';
import docs24 from './components/empty-state.docs.js';
import docs25 from './components/icon.docs.js';
import docs26 from './components/kanban-board.docs.js';
import docs27 from './components/key-value-row.docs.js';
import docs28 from './components/listing-card.docs.js';
import docs29 from './components/pill-container.docs.js';
import docs30 from './components/prose.docs.js';
import docs31 from './components/skeleton-block.docs.js';
import docs32 from './components/split-view.docs.js';
import docs33 from './components/stat-tile.docs.js';
import docs34 from './components/channel-list.docs.js';
import docs35 from './components/mention-picker.docs.js';
import docs36 from './components/message-bubble.docs.js';
import docs37 from './components/message-composer.docs.js';
import docs38 from './components/message-stream.docs.js';
import docs39 from './components/typing-indicator.docs.js';
import docs40 from './components/workspace-rail.docs.js';
import docs41 from './components/ask-box.docs.js';
import docs42 from './components/extract-review.docs.js';
import docs43 from './components/summary-panel.docs.js';
import docs44 from './components/checkbox-field.docs.js';
import docs45 from './components/date-field.docs.js';
import docs46 from './components/field-renderer.docs.js';
import docs47 from './components/file-field.docs.js';
import docs48 from './components/location-field.docs.js';
import docs49 from './components/lookup-field.docs.js';
import docs50 from './components/number-field.docs.js';
import docs51 from './components/ordered-picker.docs.js';
import docs52 from './components/picklist-field.docs.js';
import docs53 from './components/text-field.docs.js';
import docs54 from './components/action-bar.docs.js';
import docs55 from './components/button.docs.js';
import docs56 from './components/button-group.docs.js';
import docs57 from './components/overflow-menu.docs.js';
import docs58 from './components/access-denied-panel.docs.js';
import docs59 from './components/coverage-list.docs.js';
import docs60 from './components/error-panel.docs.js';
import docs61 from './components/impersonation-banner.docs.js';
import docs62 from './components/inline-hint.docs.js';
import docs63 from './components/limits-panel.docs.js';
import docs64 from './components/notice-banner.docs.js';
import docs65 from './components/page-pending.docs.js';
import docs66 from './components/progress-bar.docs.js';
import docs67 from './components/provenance-marker.docs.js';
import docs68 from './components/status-dot.docs.js';
import docs69 from './components/status-pill.docs.js';
import docs70 from './components/stepper.docs.js';
import docs71 from './components/tag.docs.js';
import docs72 from './components/usage-bar.docs.js';
import docs73 from './components/validation-summary.docs.js';
import docs74 from './components/overlay.docs.js';
import docs75 from './components/toast.docs.js';
import docs76 from './components/toast-stack.docs.js';
import docs77 from './components/tooltip.docs.js';
import docs78 from './components/code-editor.docs.js';
import docs79 from './components/inspector.docs.js';
import docs80 from './components/base-field.docs.js';
import docs81 from './components/icons.docs.js';
import docs82 from './components/artifact-list.docs.js';
import docs83 from './components/compare-view.docs.js';
import docs84 from './components/data-loader.docs.js';
import docs85 from './components/difference-modal.docs.js';
import docs86 from './components/environment-connector.docs.js';
import docs87 from './components/log-list.docs.js';
import docs88 from './components/log-viewer.docs.js';
import docs89 from './components/object-field-explorer.docs.js';
import docs90 from './components/query-editor.docs.js';
import docs91 from './components/record-field-inspector.docs.js';
import docs92 from './components/relationship-list.docs.js';
import docs93 from './components/rest-console.docs.js';
import docs94 from './components/result-grid.docs.js';
import docs95 from './components/test-result-table.docs.js';
import docs96 from './components/test-run-grid.docs.js';
import docs97 from './components/trace-flag-control.docs.js';

/** Keyed by catalogue name — the one address every piece has, element or not. */
export const COMPONENT_DOCS: ReadonlyMap<string, ComponentDocs> = new Map<string, ComponentDocs>([
  ["AppLauncher", docs0],
  ["Breadcrumb", docs1],
  ["NavGadget", docs2],
  ["ObjectCaret", docs3],
  ["OpenRecords", docs4],
  ["Topbar", docs5],
  ["Tree", docs6],
  ["WorkspaceTabs", docs7],
  ["WorkTabs", docs8],
  ["Layout", docs9],
  ["LayoutItem", docs10],
  ["Spacer", docs11],
  ["AppHome", docs12],
  ["PageHeader", docs13],
  ["RecordHeader", docs14],
  ["SegmentedFilter", docs15],
  ["TabStrip", docs16],
  ["Accordion", docs17],
  ["Avatar", docs18],
  ["CardGrid", docs19],
  ["Carousel", docs20],
  ["Chart", docs21],
  ["DataTable", docs22],
  ["DetailSection", docs23],
  ["EmptyState", docs24],
  ["Icon", docs25],
  ["KanbanBoard", docs26],
  ["KeyValueRow", docs27],
  ["ListingCard", docs28],
  ["PillContainer", docs29],
  ["Prose", docs30],
  ["SkeletonBlock", docs31],
  ["SplitView", docs32],
  ["StatTile", docs33],
  ["ChannelList", docs34],
  ["MentionPicker", docs35],
  ["MessageBubble", docs36],
  ["MessageComposer", docs37],
  ["MessageStream", docs38],
  ["TypingIndicator", docs39],
  ["WorkspaceRail", docs40],
  ["AskBox", docs41],
  ["ExtractReview", docs42],
  ["SummaryPanel", docs43],
  ["CheckboxField", docs44],
  ["DateField", docs45],
  ["FieldRenderer", docs46],
  ["FileField", docs47],
  ["LocationField", docs48],
  ["LookupField", docs49],
  ["NumberField", docs50],
  ["OrderedPicker", docs51],
  ["PicklistField", docs52],
  ["TextField", docs53],
  ["ActionBar", docs54],
  ["Button", docs55],
  ["ButtonGroup", docs56],
  ["OverflowMenu", docs57],
  ["AccessDeniedPanel", docs58],
  ["CoverageList", docs59],
  ["ErrorPanel", docs60],
  ["ImpersonationBanner", docs61],
  ["InlineHint", docs62],
  ["LimitsPanel", docs63],
  ["NoticeBanner", docs64],
  ["PagePending", docs65],
  ["ProgressBar", docs66],
  ["ProvenanceMarker", docs67],
  ["StatusDot", docs68],
  ["StatusPill", docs69],
  ["Stepper", docs70],
  ["Tag", docs71],
  ["UsageBar", docs72],
  ["ValidationSummary", docs73],
  ["Overlay", docs74],
  ["Toast", docs75],
  ["ToastStack", docs76],
  ["Tooltip", docs77],
  ["CodeEditor", docs78],
  ["Inspector", docs79],
  ["BaseField", docs80],
  ["Icons", docs81],
  ["ArtifactList", docs82],
  ["CompareView", docs83],
  ["DataLoader", docs84],
  ["DifferenceModal", docs85],
  ["EnvironmentConnector", docs86],
  ["LogList", docs87],
  ["LogViewer", docs88],
  ["ObjectFieldExplorer", docs89],
  ["QueryEditor", docs90],
  ["RecordFieldInspector", docs91],
  ["RelationshipList", docs92],
  ["RestConsole", docs93],
  ["ResultGrid", docs94],
  ["TestResultTable", docs95],
  ["TestRunGrid", docs96],
  ["TraceFlagControl", docs97],
]);

/** What one piece says about itself, or `undefined` when it has not said anything at all. */
export function docsFor(name: string): ComponentDocs | undefined {
  return COMPONENT_DOCS.get(name);
}
